















































































import Vue, { PropType } from 'vue'
import Pagination from '@/components/Pagination.vue'
import Teaser from '@/components/Teaser.vue'
import { Dataset } from '@/types/dataset'
import { FormField, Option } from '@/types/formField'
import { Row } from '@/types/row'

export default Vue.extend({
  name: 'OdpMasterDetail',
  components: {
    Detail: () => import('@/components/Detail.vue'),
    OdpMap: () => import('@/components/Map.vue'),
    Teaser,
    Pagination
  },
  props: {
    source: {
      type: String,
      default: 'https://data.stad.gent/api/records/1.0/search/?dataset='
    },
    dataset: {
      type: String,
      required: true
    },
    query: {
      type: String,
      default: 'Zoek op trefwoord'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    formFields: {
      type: Array as PropType<FormField[]>,
      default: () => []
    },
    sort: {
      type: String,
      required: false
    },
    random: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'cs--cyan'
    }
  },
  data () {
    return {
      items: [] as Row[],
      allItems: [] as Row[],
      images: false,
      total: 0,
      offset: 0,
      loading: true,
      noResult: true,
      q: null,
      myFormFields: [] as FormField[],
      selectedRecord: null as (Row | null),
      trigger: null as (HTMLElement | null),
      showMap: false,
      hasMap: false
    }
  },
  watch: {
    formFields (v: FormField[]) {
      this.myFormFields = v
    }
  },
  computed: {
    page (): number {
      return Math.floor(this.offset / 12) + 1
    }
  },
  methods: {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    randomList: function (rand: any) {
      return rand.slice().sort(function () { return 0.5 - Math.random() })
    },
    splitOptions: function (options: [Option | string]): Option[] {
      return options.map((o: Option | string) => typeof o === 'string' ? { name: o, value: o } : o)
    },
    createUrl (paged: boolean): string {
      const fields = this.myFormFields.filter(f => !!f.value)
      let url

      if (paged) {
        url = `${this.source}${this.dataset}&rows=12&start=${this.offset}${this.sort ? '&sort=' + this.sort : ''}&q=`
      } else {
        url = `${this.source}${this.dataset}&rows=1000${this.sort ? '&sort=' + this.sort : ''}&q=`
      }

      if (this.query && this.q) {
        url += `${this.q}${fields?.length ? ' and ' : ''}`
      }
      url += fields.map((f: FormField) => `${f.column}:'${f.value}'`).join(' and ')

      return url
    },
    async fetchAll (): Promise<void> {
      this.allItems = []
      const url = this.createUrl(false)
      const response = await fetch(url)
      if (!response.ok) {
        this.allItems = []
        this.noResult = true
        this.loading = false
        this.total = 0
        return
      }

      const { records }: Dataset = await response.json()
      records.length === 0 ? this.noResult = true : this.noResult = false
      this.allItems = records.map(({ fields }) => fields)
      this.hasMap = !!this.allItems[0]?.coordinates
    },
    async fetch (hash: boolean): Promise<void> {
      this.loading = true
      this.items = []
      let url = ''

      hash ? url = this.createUrl(false) : url = this.createUrl(true)

      const response = await fetch(url)
      if (!response.ok) {
        this.noResult = true
        this.loading = false
        this.total = 0
        return
      }

      const {
        nhits,
        records
      }: Dataset = await response.json()

      records.length === 0 ? this.noResult = true : this.noResult = false

      this.total = Math.ceil(nhits / 12)
      this.items = records.map(({ fields }) => fields)

      for (let i = 0; i < records.length; i++) {
        this.items[i].recordid = records[i].recordid
      }

      this.hasMap = !!this.items[0]?.coordinates
      this.images = false

      for (let i = 0; i < this.items.length; i++) {
        if ((this.images = !!this.items[i]?.teaser_img_url) === true) {
          break
        }
      }

      /**
       * reset pagination if needed
       */
      if (nhits < this.offset) {
        this.offset = 0
        await this.fetch(false)
      }

      this.loading = false
    },
    async firstFetch (): Promise<void> {
      this.offset = 0
      this.emitFilter()
      const hash = window.location.hash.replace('#', '')
      let hashBool = false

      hash ? hashBool = true : hashBool = false

      await this.fetch(hashBool)
      if (this.hasMap) {
        await this.fetchAll()
      }
    },
    async search (): Promise<void> {
      await this.firstFetch()
      const grid = this.$refs.grid as HTMLElement
      if (grid) {
        grid.focus()
      }
    },
    emitFilter (): void {
      const formValue: { [key: string]: unknown } = {
        q: this.q
      }
      this.myFormFields.forEach((f: FormField) => {
        formValue[f.column] = f.value
      })
      this.$emit('filter', formValue)
    },
    setTrigger ({ currentTarget }: Event): void {
      this.trigger = currentTarget as HTMLElement
    },
    async back (): Promise<void> {
      location.hash = ''
      await this.fetch(false)
    },
    onHashChange (): void {
      const hash = window.location.hash.replace('#', '')
      if (!hash) {
        this.selectedRecord = null
        setTimeout(() => {
          if (this.trigger !== null) {
            this.trigger.focus()
          }
        })
        return
      }

      const row = this.items.find(i => i.recordid === hash)
      if (row) {
        this.selectedRecord = row
        this.$emit('detail', JSON.parse(JSON.stringify(row)))
      }
    },
    async navigate (page: number): Promise<void> {
      this.offset = (page - 1) * 12
      await this.fetch(false)
      const grid = this.$refs.grid as HTMLElement
      if (grid) {
        grid.focus()
      }
    }
  },
  async mounted (): Promise<void> {
    this.myFormFields = this.formFields
    await this.firstFetch()
    window.addEventListener('hashchange', this.onHashChange)
    this.onHashChange()

    /**
     * Gent_styleguide expects a document font-size of 20px
     * and uses REM for all styling.
     *
     * If the document embedding this component does not have a 20px font-size,
     * this part will increase all REM values in all CSS rules.
     * Obviously, this is to be avoided...
     */
    try {
      const docFontSize = +getComputedStyle(document.documentElement).fontSize.replace('px', '')
      // eslint-disable-next-line
      console.warn('DocFontsize is ' + docFontSize + '. Adjusting font-sizes now, but this impacts performance.')

      if (docFontSize === 20) {
        return
      }

      const docFontSizeAdjust = 20 / docFontSize
      const { shadowRoot } = this.$parent.$options as { shadowRoot: ShadowRoot }
      const sheets = shadowRoot.styleSheets

      const changeRule = (rule: CSSRule) => {
        if (rule instanceof CSSStyleRule) {
          const style = rule.style
          style.cssText = style.cssText.replace(/(\d*[.]*\d*)(rem[ ;})])/g, (match, p1, p2) => (p1 * docFontSizeAdjust) + p2)
        } else if (rule instanceof CSSMediaRule) {
          for (let i = rule.cssRules.length; i--;) {
            changeRule(rule.cssRules[i])
          }
        }
      }

      for (let i = sheets.length; i--;) {
        const sheet = sheets[i]
        for (let i = sheet.cssRules.length; i--;) {
          changeRule(sheet.cssRules[i])
        }
      }
    } catch (e) {
      // eslint-disable-next-line
      console.error(e)
    }
  }
})
